import { AggregationType } from "types/charts";

export enum WalletMetrics {
  UNITS_ISSUED = "unitsIssued",
  UNITS_ACTIVE = "unitsActive",
  BREAKAGE_RATE = "breakageRate",
  REDEMPTION_RATE = "redemptionRate",
  UNITS_PENDING = "unitsPending",
  UNITS_SPENT = "unitsSpent",
  UNITS_EXPIRED = "unitsExpired",
}

export type WalletMetricsUnion = `${WalletMetrics}`;

type WalletDataHeader = {
  [Property in WalletMetricsUnion]: number;
};

export type UnitsWalletOverviewData = {
  dataType: string;
  aggregationType: AggregationType;
  intervalStartDate: string;
  intervalEndDate: string;
  header: WalletDataHeader;
  data: {
    [key: string]: number;
  };
};
